import {Toast} from './toast-index';

export const throwToast = (message, toastType) => {
  let element = document.createElement('div');
  element.textContent = message;
  let newToast = new Toast(element, toastType, Toast.TIME_NORMAL);
  element.addEventListener('click', () => newToast.delete());
};